'use strict';
const angular = require('angular');

const uiRouter = require('angular-ui-router');

import routes from './user-directory.routes';

export class UserDirectoryComponent {
  constructor(User, DTOptionsBuilder, $state, Config) {
    'ngInject';

    this.pageTitle = Config.getPageTitleByStateWithDefault($state.current.name, "User Directory");

    this.dtOptions = DTOptionsBuilder.newOptions()
      .withOption('dom', 'lBfrtip')
      .withOption('responsive', true)
      .withOption('order', [0, 'asc'])
      .withOption('buttons',[{
        extend: 'excel',
        title: 'User Directory'
      },{
        extend: 'csv',
        title: 'User Directory'
      },{
        title: 'User Directory',
        message: 'As of ' + moment().format("MMMM Do YYYY"),
        extend: 'pdf',
        orientation: 'landscape',
        pageSize: 'LETTER'
      },'print']);

    this.data = User.query();
  }
}

export default angular.module('conduuApp.userDirectory', [uiRouter])
  .config(routes)
  .component('userDirectory', {
    template: require('./user-directory.html'),
    controller: UserDirectoryComponent,
    controllerAs: 'ctrl'
  })
  .name;



// WEBPACK FOOTER //
// ./client/app/directories/user/user-directory.component.js